import React from 'react';
import { Bell, CheckCircle2, type LucideIcon } from 'lucide-react';
import { Notification } from '@/lib/api';
import { cn, timeAgo } from '@/lib/utils';

const TYPE_ICONS: Record<string, LucideIcon> = {
  analysis_completed: CheckCircle2,
};

interface NotificationRowProps {
  notification: Notification;
  compact?: boolean;
}

// Renders the row body only — the clickable wrapper differs per surface
// (DropdownMenuItem in the bell, a button on the page).
export const NotificationRow: React.FC<NotificationRowProps> = ({ notification: n, compact }) => {
  const Icon = TYPE_ICONS[n.type] ?? Bell;

  return (
    <div className="flex w-full items-start gap-2">
      <Icon
        className={cn(
          'mt-[2px] flex-shrink-0 text-muted-foreground',
          compact ? 'h-[13px] w-[13px]' : 'h-[15px] w-[15px]'
        )}
      />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          {!n.read_at && <span className="h-[6px] w-[6px] flex-shrink-0 rounded-full bg-sev-critical" />}
          <span className={cn('font-medium leading-tight', compact ? 'text-[12px]' : 'text-[13px]')}>
            {n.title}
          </span>
        </div>
        {n.body && (
          <p className={cn('mt-[2px] text-muted-foreground', compact ? 'text-[11px]' : 'text-[12px]')}>
            {n.body}
          </p>
        )}
        <span className="mt-[2px] block font-mono text-[10px] text-muted-foreground">
          {timeAgo(n.created_at)}
        </span>
      </div>
    </div>
  );
};
